import { render, staticRenderFns } from "./VFooter.vue?vue&type=template&id=0aa2ccd2&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa2ccd2",
  null
  
)

export default component.exports